import React, { useEffect, useState } from "react";
import axios from "axios";

const AdminPage = ({ onLogout }) => {
  const [contacts, setContacts] = useState([]);
  const [inquiries, setInquiry] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);
  const [inquiryToDelete, setInquiryToDelete] = useState(null);
  const [activeTab, setActiveTab] = useState("Contact"); // State for active tab

  const fetchContacts = async () => {
    try {
      const response = await axios.get("https://training.megascale.co.in/backend/get_contacts.php");
      console.log("Fetched Contacts Data:", response.data.contacts);
      setContacts(response.data.contacts); // Use response.data.contacts
    } catch (error) {
      console.error("Error fetching contacts:", error.response ? error.response.data : error.message);
    }
  };

  const fetchInquiryData = async () => {
    try {
      const response = await axios.get("https://training.megascale.co.in/backend/get_contacts.php");
      console.log("Fetched Inquiry Data:", response.data.inquiries);
      setInquiry(response.data.inquiries); // Use response.data.inquiries
    } catch (error) {
      console.error("Error fetching inquiry:", error.response ? error.response.data : error.message);
    }
  };



  useEffect(() => {
    fetchContacts();
    fetchInquiryData();
  }, []);

  // Delete Contact function
  const deleteContact = async () => {
    if (contactToDelete) {
      try {
        const response = await axios.delete(
          "https://training.megascale.co.in/backend/delete_contact.php", // API URL
          {
            data: { contact_id: contactToDelete },
          }
        );
        console.log("Deleted Contact:", response.data);
        fetchContacts();
        setContacts(contacts.filter((contact) => contact.id !== contactToDelete));
        setShowModal(false);
        setContactToDelete(null);
      } catch (error) {
        console.error("Error deleting contact:", error);
        fetchContacts();
      }
    }
  };

  // Delete Inquiry function
  const deleteInquiry = async () => {
    if (inquiryToDelete) {
      try {
        const response = await axios.delete(
          "https://training.megascale.co.in/backend/delete_contact.php", // API URL
          {
            data: { inquiry_id: inquiryToDelete },
          }
        );
        console.log("Deleted Inquiry:", response.data);
        fetchInquiryData();
        setInquiry(inquiries.filter((inquiry) => inquiry.id !== inquiryToDelete));
        setShowModal(false);
        setInquiryToDelete(null);
      } catch (error) {
        console.error("Error deleting inquiry:", error);
        fetchInquiryData();
      }
    }
  };

  return (
    <>
      {/* Modal for confirmation */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-96 h-auto">
            <h2 className="text-xl font-semibold mb-4">
              Are you sure you want to delete this {activeTab === "Contact" ? 'contact?' : 'Inquiry?'}
            </h2>
            <div className="flex justify-between">
              <button
                onClick={() => setShowModal(false)}
                className="bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600"
              >
                Cancel
              </button>
              <button
                onClick={activeTab === "Contact" ? deleteContact : deleteInquiry}  // Conditional function call
                className="bg-red-500 text-white py-2 px-4 rounded-lg hover:bg-red-600"
              >
                Delete
              </button>

            </div>
          </div>
        </div>
      )}
     

      {/* Tab Navigation */}
      <div className="flex justify-center pt-32">
        {["Contact", "Inquiry"].map((tab) => (
          <button
            key={tab}
            className={`relative px-14 py-2 font-semibold md:text-xl text-lg rounded-md transition-all duration-300 ${activeTab === tab
                ? "text-indigo-600 border-b-4 border-indigo-600 shadow-lg"
                : "text-gray-600 hover:text-indigo-600"
              }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
            {activeTab === tab && (
              <div className="absolute bottom-0 left-0 w-full h-1 bg-indigo-600 rounded-full" />
            )}
          </button>
        ))}
      </div>
     


      {/* Tab Content */}
      {activeTab === "Contact" ? (
        <div className="flex flex-col justify-center items-center min-h-screen bg-gray-100 px-4">


          <div className="w-full max-w-6xl bg-white mb-10 rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-semibold mb-4 text-center">Contact Data</h2>

            {/* Table View */}
            <div className="hidden md:block overflow-x-auto">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                  <th className="border border-gray-300 px-2 sm:px-4 py-2">No</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Name</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Email</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Phone Number</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Service</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Message</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.length > 0 ? (
                    contacts.map((contact, index) => (
                      <tr key={contact.id} className="hover:bg-gray-100">
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 text-center">
                        {index + 1}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 whitespace-nowrap">
                          {`${contact.first_name} ${contact.last_name}`}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {contact.email}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {contact.phone_number}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {contact.service}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {contact.message}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 text-center">
                          <button
                            onClick={() => {
                              setContactToDelete(contact.id);
                              setShowModal(true);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        className="border border-gray-300 px-2 sm:px-4 py-2 text-center"
                      >
                        No contact data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Card View */}
            <div className="block md:hidden">
              {contacts.length > 0 ? (
                contacts.map((contact, index) => (
                  <div
                    key={contact.id}
                    className="mb-4 p-4 border border-gray-300 rounded-lg shadow-sm bg-gray-50"
                  >
                    <p className="font-semibold">
                      No: <span className="font-normal">{index + 1}</span>
                    </p>
                    <p className="font-semibold">
                      Name:{" "}
                      <span className="font-normal">
                        {`${contact.first_name} ${contact.last_name}`}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Email: <span className="font-normal">{contact.email}</span>
                    </p>
                    <p className="font-semibold">
                      Phone Number:{" "}
                      <span className="font-normal">{contact.phone_number}</span>
                    </p>
                    <p className="font-semibold">
                      Service: <span className="font-normal">{contact.service}</span>
                    </p>
                    <p className="font-semibold">
                      Message: <span className="font-normal">{contact.message}</span>
                    </p>
                    <button
                      onClick={() => {
                        setContactToDelete(contact.id);
                        setShowModal(true);
                      }}
                      className="text-red-500 hover:text-red-700 mt-4"
                    >
                      Delete
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-center">No contact data available.</p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col pt-10 items-center min-h-screen bg-gray-100 px-4">
          <div className="w-full max-w-6xl bg-white mb-10 rounded-lg shadow-md p-6">
            <h2 className="text-2xl font-semibold mb-4 text-center">inquiry Data</h2>

            {/* Table View */}
            <div className="hidden md:block overflow-x-auto">
              <table className="table-auto w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-200">
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">No</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Name</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Email</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Phone Number</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">position</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Message</th>
                    <th className="border border-gray-300 px-2 sm:px-4 py-2">Actions</th>

                  </tr>
                </thead>
                <tbody>
                  {inquiries.length > 0 ? (
                    inquiries.map((inquiri,index) => (
                      <tr key={inquiri.id} className="hover:bg-gray-100">
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 text-center">
                        {index + 1}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 whitespace-nowrap">
                          {inquiri.name}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {inquiri.email}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {inquiri.phone}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {inquiri.position}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2">
                          {inquiri.message}
                        </td>
                        <td className="border border-gray-300 px-2 sm:px-4 py-2 text-center">
                          <button
                            onClick={() => {
                              setInquiryToDelete(inquiri.id);
                              setShowModal(true);
                            }}
                            className="text-red-500 hover:text-red-700"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="8"
                        className="border border-gray-300 px-2 sm:px-4 py-2 text-center"
                      >
                        No inquiry data available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Card View */}
            <div className="block md:hidden">
              {inquiries.length > 0 ? (
                inquiries.map((inquiri,index) => (
                  <div
                    key={inquiri.id}
                    className="mb-4 p-4 border border-gray-300 rounded-lg shadow-sm bg-gray-50"
                  >
                    <p className="font-semibold">
                      No: <span className="font-normal">{index + 1}</span>
                    </p>
                    <p className="font-semibold">
                      Name:{" "}
                      <span className="font-normal">
                        {inquiri.name}
                      </span>
                    </p>
                    <p className="font-semibold">
                      Email: <span className="font-normal">{inquiri.email}</span>
                    </p>
                    <p className="font-semibold">
                      Phone Number:{" "}
                      <span className="font-normal">{inquiri.phone}</span>
                    </p>
                    <p className="font-semibold">
                      Service: <span className="font-normal">{inquiri.position}</span>
                    </p>
                    <p className="font-semibold">
                      Message: <span className="font-normal">{inquiri.message}</span>
                    </p>
                    <button
                      onClick={() => {
                        setInquiryToDelete(inquiri.id);
                        setShowModal(true);
                      }}
                      className="text-red-500 hover:text-red-700 mt-4"
                    >
                      Delete
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-center">No inquiry data available.</p>
              )}
            </div>
          </div>
        </div>
      )}


    </>
  );
};

export default AdminPage;
